// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__programTagImg {
  max-height: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProgramTag/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB","sourcesContent":[".programTagImg {\n  max-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export var programTagImg = `styles__programTagImg`;
export default ___CSS_LOADER_EXPORT___;
